import { ScrollContainer as FoundationsScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollingBodyContainer = ({
  children,
  ScrollContainer,
  'data-test-id': dataTestId,
  id
}) => {
  return /*#__PURE__*/_jsx(FoundationsScrollContainer, {
    id: id,
    ScrollContainer: ScrollContainer,
    "data-test-id": dataTestId,
    children: children
  });
};
export default ScrollingBodyContainer;